import { Box, Typography } from '@mui/material';
import { useEffect, useLayoutEffect, useRef, useState } from 'react';

const MarqueeText = ({ children, animationDuration = '7s' }) => {
  const containerRef = useRef(null);
  const textRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [shouldAnimate, setShouldAnimate] = useState(false);

  // Track container width changes (responsive)
  useLayoutEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    const ro = new ResizeObserver(entries => {
      const w = entries[0].contentRect.width;
      setContainerWidth(w);
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  // Enable animation only if text is wider than its container
  useEffect(() => {
    const t = textRef.current;
    if (!t || !containerWidth) return;
    setShouldAnimate(t.scrollWidth > containerWidth + 1); // +1 for rounding
  }, [children, containerWidth]);

  return (
    <Box ref={containerRef} sx={{ width: '100%', overflow: 'hidden', display: 'inline-block' }}>
      <Typography
        ref={textRef}
        variant="body1"
        sx={{
          fontSize: '.9rem',
          whiteSpace: 'nowrap',
          display: 'inline-flex',
          alignItems: 'center',
          height: '100%',
          ...(shouldAnimate && {
            animation: `marquee ${animationDuration} ease-in-out infinite alternate`,
            '@keyframes marquee': {
              '0%': { transform: 'translateX(0)' },
              '100%': { transform: `translateX(calc(${containerWidth}px - 100%))` },
            },
            '&:hover': { animationPlayState: 'paused' },
          }),
        }}>
        {children}
      </Typography>
    </Box>
  );
};

export default MarqueeText;
